import request from '@/util/server.js'
// 登录模块
// 图文验证
export function getCodeBefore (params) {
  return request({
    url: '/app/getCodeBefore',
    method: 'get',
    params
  })
}
// 获取验证码
export function getTheCode (params) {
  return request({
    url: '/app/getCode',
    method: 'get',
    params
  })
}

// 登录
export function login (data) {
  return request({
    url: '/app/login',
    method: 'post',
    data
  })
}
// 统一登录接口
export function unifiedLogin (data) {
  return request({
    url: '/app/unifiedLogin',
    method: 'post',
    data
  })
}

// 修改密码
export function updatePassword (data) {
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgetPassword (data) {
  return request({
    url: '/app/forgetPassword',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js